<template>
  <FilterSelectorItem
    v-if="hasOptions"
    v-model:query="menuQuery"
    :label="filterLabel"
    :options="displayedOptionsArray"
    :variant="variant"
    :has-search="hasSearch"
    @open="handleMenuOpen"
    @close="handleMenuClose"
    @reset="handleMenuReset"
    @option-selected="handleFilterChange" />
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed } from "vue";

import useFilterItem from "@/composition/archive/useFilterItem.ts";
import { useFilterSelectorMenu } from "@/composition/archive/useFilterSelectorMenu.ts";
import useFilterSelectorStore from "@/stores/search/filterSelector.ts";

import FilterSelectorItem from "./FilterSelectorItem.vue";
import type { FilterSelectorItemWrapperProps } from "./filterSelectorItemWrapper";

const { variant } = defineProps<FilterSelectorItemWrapperProps>();

const filterSelectorStore = useFilterSelectorStore();
const { selectedGenres, genreFilter } = storeToRefs(filterSelectorStore);

const { handleFilterChange, filterLabel } = useFilterItem(
  genreFilter,
  selectedGenres,
);

const genreOptions = computed(() => genreFilter.value?.options ?? []);

const {
  menuQuery,
  hasOptions,
  hasSearch,
  handleMenuOpen,
  handleMenuClose,
  handleMenuReset,
  displayedOptions,
} = useFilterSelectorMenu(genreOptions, handleFilterChange, 10);

const displayedOptionsArray = computed(() => displayedOptions.value);
</script>
